import { Address, CompliancePermissionLevelPerStatus, FieldType } from '@pmp/api';
import React from 'react';
import { DescriptionsItemType } from 'antd/es/descriptions';
import { t } from 'i18next';

export const formatAddress = (address: Address) => {
  const addressOrder = ['name', 'numberOrBuilding', 'lineItems', 'city', 'postCode', 'country'];

  return (
    <>
      {addressOrder.map(item => {
        const value = address[item as keyof Address];
        if (!value) return null;
        if (item === 'lineItems' && Array.isArray(value)) {
          return value.map((li, idx) => (
            <React.Fragment key={item + idx}>
              {li}
              <br />
            </React.Fragment>
          ));
        }
        return (
          <React.Fragment key={item}>
            {value}
            <br />
          </React.Fragment>
        );
      })}
    </>
  );
};

export const getComplianceItems = (data?: Array<CompliancePermissionLevelPerStatus> | null): DescriptionsItemType[] => {
  if (!data) return [];
  return data.map(({ complianceStatus, permissionLevel }) => {
    return {
      key: complianceStatus ?? '',
      label: t(`lender.lender.labels.${complianceStatus ?? ''}`),
      children: t(`lender.lender.labels.${permissionLevel ?? ''}`),
    };
  });
};
